import styled from 'styled-components';
import ReactSelect from 'react-select';
import {
  tabletThresholdPixels, fontSizes, colors, frames,
} from '../home/v3/styledComponents';

type RowType = {
  gap?: boolean;
  marginTop?: number;
  mobileMarginTop?: number;
  marginBottom?: boolean;
};
export const Row = styled.div<RowType>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  ${({ marginBottom }) => marginBottom && 'margin-bottom: 60px;'};
  ${({ marginTop }) => marginTop && 'margin-top: 100px;'};
  gap: ${(props) => props.gap ? '30px' : ''};

  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
    margin: auto;
    align-items: center;
    gap: ${(props) => props.gap ? '14px' : ''};
    ${(props) => props.mobileMarginTop && `margin-top: ${props.mobileMarginTop}px;`}
    width: calc(100vw - (${frames.mobile}*2));
  }
`;

export const Row2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: left;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
    margin: 0;
    width: 100%;
  }
`;

export const TreeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Title = styled.section`
  font-weight: 700;
  font-size: 34px;
  color: ${colors.black};

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 25px;
    max-width: 345px;
  }
`;

type SubtitleType = {
  marginTop?: number;
};
export const Subtitle = styled.section<SubtitleType>`
  font-weight: 700;
  font-size: 110px;
  text-transform: uppercase;
  text-align: left;
  color: ${colors.black};
  ${(props) => props.marginTop && 'margin-top: 100px;'}

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 35px;
  }
`;

type ContentType = {
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: boolean;
  small?: boolean;
  flexStart?: boolean;
  mobileNoMarginTop?: boolean;
};
export const Content = styled.div<ContentType>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.flexStart ? 'flex-start' : 'center'};
  width: 100%;
  align-content: ${(props) => props.flexStart ? 'flex-start' : 'center'};
  margin: ${(props) => props.small ? '50px' : '0px'};
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px;`};
  flex-wrap: wrap;

  @media (max-width: ${tabletThresholdPixels}) {
    ${(props) => props.mobileNoMarginTop && 'margin-top: 0px;'};
    margin-bottom: ${(props) => props.marginBottom || '0px'};
    margin-left: ${(props) => props.marginLeft ? '62px' : '0px'};
    width: 100%;
  }
`;

export const SmallContent = styled(Content)`
  ${(marginBottom) => marginBottom ? 'margin: 0px 0px 64px 100px' : 'margin: 0px 0px 0px 100px'};
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px;`}

  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0;
  }
`;

type CardsContainerType = {
  littleCard?: boolean;
  marginTop?: number;
  mobileNoMarginTop?: boolean;
};
export const CardsContainer = styled.div<CardsContainerType>`
  display: grid;
  grid-template-columns: repeat(${({ littleCard }) => littleCard ? '4' : '3'}, 1fr);
  gap: 32px;
  width: 100%;
  height: auto;
  margin: 64px 0;
  ${(props) => props.marginTop && `margin-top: ${props.marginTop}px;`}

  @media (max-width: ${tabletThresholdPixels}) {
    grid-template-columns: repeat(${({ littleCard }) => littleCard ? '2' : '1'}, 1fr);
    grid-gap: 10px 14px;
    ${(props) => props.mobileNoMarginTop && 'margin-top: 0px;'}
    justify-content: space-between;
    margin: 40px 0 0;
  }
`;

type QuestionType = {
  light?: boolean;
};
export const Question = styled.div<QuestionType>`
  display: flex;
  font-family: Roboto;
  font-weight: ${(props) => props.light ? '400' : '700'};
  font-size: 16px;
  color: ${colors.black};

  @media (max-width: ${tabletThresholdPixels}) {
    margin-left: 0px;
    font-size: 14px;
    margin-bottom: 0;
  }
`;

export const customStyles = {
  control: (base: any) => ({
    ...base,
    borderColor: colors.black,
    color: colors.black,
    textAlign: 'center',
    height: '57px',
    width: '170px',
    fontFamily: 'Roboto',
    fontSize: '16px',
    borderRadius: '4px',
    boxShadow: 0,
    padding: 0,
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${colors.black}`,
    },
  }),
  singleValue: (base: any) => ({
    ...base,
    color: colors.black,
    fontWeight: '400',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: colors.black,
    paddingLeft: 0,
    '&:hover': {
      color: colors.black,
    },
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    backgroundColor: 'none',
    padding: 0,
  }),
};

export const setTheme = (theme: any) => (
  {
    ...theme,
    colors: {
      ...theme.colors,
      primary: colors.black,
      primary25: colors.grey50,
      primary50: colors.grey50,
      neutral50: colors.blue800,
    },
  }
);

export const Select = styled(ReactSelect)`
  width: 170px;
  @media (max-width: ${tabletThresholdPixels}) {
    margin-left: 0;
    width: 100%;
  }
`;

export const Label = styled.p`
  font-size: 12px;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  text-transform: uppercase;

  @media (max-width: ${tabletThresholdPixels}) {
    text-transform: uppercase;
  }
`;

type AnswerCardType = {
  isActive?: boolean;
  isAvailable?: boolean;
  extraMarginBottom?: boolean;
  cardWithImage?: boolean;
};
export const AnswerCard = styled.button<AnswerCardType>`
  min-height: 57px;
  width: 244px;
  border-radius: 4px;
  background-color: ${(props) => props.isActive ? colors.black : colors.beige100};
  color: ${(props) => props.isActive ? colors.beige100 : colors.black};
  ${(props) => props.isAvailable !== undefined
    && !props.isAvailable
    && `color: ${colors.grey200}; pointer-events: none;`}
  border: 0.75px solid ${colors.black};
  box-sizing: border-box;
  outline: 0;
  cursor: pointer;
  transition: all 0.5s ease;
  padding: 10px;

  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    ${(props) => props.extraMarginBottom && 'margin-bottom: 25px;'};
    ${(props) => props.cardWithImage && 'min-height: 34px;'};
  }
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
  }
`;

export { tabletThresholdPixels, fontSizes, colors };

export const createRange = (min: number, max: number) => {
  const range = [];
  for (let i = min; i < max + 1; i += 1) {
    range.push({ value: i, label: i.toString() });
  }
  return range;
};

export const LineHorizontal = styled.div`
  background-color: ${colors.black};
  height: 1px;
  margin: 0;
  width: 100%;
  margin-top: 40px;
`;

type OrderStepHeaderType = {
  littleTypo?: boolean;
  knitPath?: boolean;
  noMarginTop?: boolean;
};
export const OrderStepHeader = styled.div<OrderStepHeaderType>`
  font-weight: 700;
  font-size: 96px;
  text-transform: uppercase;
  margin-top: 64px;
  max-width: 100%;
  ${(props) => props.littleTypo && 'font-size: 34px; text-transform: none;'};
  ${(props) => props.knitPath && 'font-size: 48px; text-transform: none; letter-spacing: 2.4px; margin-top: 0;'};

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 40px;
    letter-spacing: 2px;
    margin-top: ${(props) => props.noMarginTop ? '0' : '40px'};
    ${(props) => props.littleTypo && 'font-size: 20px; text-transform: none;'};
  }
  `;

type QuestionContainerType = {
  littleGap?: boolean;
  withImage?: boolean;
  mobileColumn?: boolean;
  noMarginBottom?: boolean;
  column?: boolean;
};
export const QuestionContainer = styled.div<QuestionContainerType>`
  display: flex;
  flex-direction: ${(props) => props.column ? 'column' : 'row'};
  justify-content: flex-start;
  ${(props) => props.littleGap ? 'gap: 17px;' : 'gap: 17px 43px;'}
  flex-wrap: wrap;
  margin: 25px 0 0;
  ${(props) => props.withImage && 'display: grid; grid-template-columns: repeat(3, 250px);'}

  @media (max-width: ${tabletThresholdPixels}) {
    ${(props) => props.withImage && 'display: grid; grid-template-columns: 1fr 1fr;'}
    ${(props) => props.mobileColumn && 'flex-direction: column;'}
    width: 100%;
    gap: 14px;
    margin: 14px 0 ${(props) => props.noMarginBottom ? '5px' : '40px'};
  }
`;

type LabelImgType = {
  isActive?: boolean;
  seeInRDV?: boolean;
};
export const LabelImg = styled.button<LabelImgType>`
  background-color: ${(props) => (props.isActive ? colors.black : colors.beige100)};
  border: 0.75px solid;
  border-color: ${colors.black};
  box-sizing: border-box;
  margin-top: 15px;
  padding: 10px;
  color: ${(props) => (props.isActive ? colors.beige100 : colors.black)};
  cursor: pointer;
  height: ${({ seeInRDV }) => seeInRDV ? '100%' : '42px'};
  justify-content: start;
  outline: 0;
  transition: all 0.5s ease;
  width: 100%;
`;

type LabelImgTextType = {
  isCentered?: boolean;
};
export const LabelImgText = styled.div<LabelImgTextType>`
  font-size: 12px;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  text-transform: uppercase;
  ${({ isCentered }) => isCentered && `
    text-align: center;
    margin-left: 0px;
  `}
`;

type TextareaType = {
  large?: boolean;
};
export const Textarea = styled.textarea<TextareaType>`
  font-family: Roboto;
  font-size: 16px;
  box-sizing: border-box;
  width: 908px;
  ${({ large }) => large ? 'width: 100%;' : 'width: 908px;'}
  height: 140px;
  border: 0.75px solid ${colors.black};
  padding: 20px 15px;
  margin: 25px 0 0;
  white-space: pre-line;
  border-radius: 4px;
  ::placeholder {
    font-size: 12px;
    font-weight: 400;
    color: ${colors.grey400}
  }
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 25px 0 50px;
    width: 100%;
    font-size: 16px;
    ::placeholder {
      font-size: 14px;
    }
  }
`;

export const Infos = styled.p`
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.6px;
  margin: 17px 0 0;
`;

export const ImgCard = styled.img`
  width: 244px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
  }
`;
